// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************************************************************
 *
 *  JournalHub -- Universal Scholarly Publishing 
 *  Copyright (C) 2022 - 2024 Daniel Bingham 
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU Affero General Public License as published
 *  by the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU Affero General Public License for more details.
 *
 *  You should have received a copy of the GNU Affero General Public License
 *  along with this program.  If not, see <https://www.gnu.org/licenses/>.
 *
 ******************************************************************************/
.notification {
    width: 250px;
    padding: 20px;
    font-size: 14px;
    background-color: white;
    border-bottom: thin solid var(--main-border-color);
    font-weight: bold;
}
.notification.read {
    background-color: var(--page-header-background-color);
    font-weight: normal;
}
.floating-menu.notification-menu .menu-body .menu-item.notification {
    white-space: normal;
}
.notification:hover {
    background-color: var(--input-highlight-color);
    color: white;
}
`, "",{"version":3,"sources":["webpack://./client/components/notifications/NotificationMenuItem.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;+EAkB+E;AAC/E;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kDAAkD;IAClD,iBAAiB;AACrB;AACA;IACI,qDAAqD;IACrD,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,8CAA8C;IAC9C,YAAY;AAChB","sourcesContent":["/******************************************************************************\n *\n *  JournalHub -- Universal Scholarly Publishing \n *  Copyright (C) 2022 - 2024 Daniel Bingham \n *\n *  This program is free software: you can redistribute it and/or modify\n *  it under the terms of the GNU Affero General Public License as published\n *  by the Free Software Foundation, either version 3 of the License, or\n *  (at your option) any later version.\n *\n *  This program is distributed in the hope that it will be useful,\n *  but WITHOUT ANY WARRANTY; without even the implied warranty of\n *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n *  GNU Affero General Public License for more details.\n *\n *  You should have received a copy of the GNU Affero General Public License\n *  along with this program.  If not, see <https://www.gnu.org/licenses/>.\n *\n ******************************************************************************/\n.notification {\n    width: 250px;\n    padding: 20px;\n    font-size: 14px;\n    background-color: white;\n    border-bottom: thin solid var(--main-border-color);\n    font-weight: bold;\n}\n.notification.read {\n    background-color: var(--page-header-background-color);\n    font-weight: normal;\n}\n.floating-menu.notification-menu .menu-body .menu-item.notification {\n    white-space: normal;\n}\n.notification:hover {\n    background-color: var(--input-highlight-color);\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
